import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user : {},
    sidenav: true,
    breadcrumbs: [],
    error: '',
    tokenAutoRefresh: localStorage.getItem('token')? false : true
  },
  getters: {
    sidenav: state => state.sidenav,
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    breadcrumbs: state => state.breadcrumbs,
    error: state => state.error,
    tokenAutoRefresh: state => state.tokenAutoRefresh
  },
  mutations: {
    setBreadcrumbs (state, breadcrumbs){
        state.breadcrumbs = breadcrumbs

    },
    toggleSideNav: (state, value) => {
      if (typeof value === 'boolean') {
        state.sidenav = value;
        return;
      }
      state.sidenav = !state.sidenav;
    },
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, token, user){
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error(state, error){
      state.status = 'error'
      state.error = error
    },
    logout(state){
      state.status = ''
      state.token = ''
    },
    refresh_token(state, token) {
      state.token = token
    },
    token_auto_refresh(state, isSet) {
      state.tokenAutoRefresh = isSet
    }
  },
  actions: {
    toggleSideNav({commit}, value) {
      commit('toggleSideNav', value)
    },
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        // TODO: store credentials somewhere
        // let username = 'bi-YDXfWtxL'
        // let password = '5c7c9ded6f91e9f774fc0a9ce90332e9da0a209146d608520df569ade0203699'
        // const token =  Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
        axios({
                url: process.env.VUE_APP_URL + '/oauth/token',
                data: 'grant_type=password&username='+ user.username +'&password='+ user.password,
                method: 'POST',
                headers: {
                  'Authorization': 'Basic YmktWURYZld0eEw6NWM3YzlkZWQ2ZjkxZTlmNzc0ZmMwYTljZTkwMzMyZTlkYTBhMjA5MTQ2ZDYwODUyMGRmNTY5YWRlMDIwMzY5OQ==',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
        })
            .then(resp => {
              const token = resp.data.access_token
              const refreshToken = resp.data.refresh_token
              const expiresIn = Date.now() + resp.data.expires_in * 1000
              // const expiresIn = Date.now() + 16 * 60 * 1000 // test
              const userObj = resp.data.user
              localStorage.setItem('token', token)
              localStorage.setItem('refresh_token', refreshToken)
              localStorage.setItem('expires_in', expiresIn)
              localStorage.setItem('username', user.username)
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              commit('auth_success', token, userObj)
              commit('token_auto_refresh', false)
              resolve(resp)
            })
            .catch(err => {
              commit('auth_error', 'Неправильный логин или пароль')
              localStorage.removeItem('token')
              localStorage.removeItem('refresh_token')
              localStorage.removeItem('expires_in')
              reject(err)
            })
      })
    },
    logout({commit}){
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('expires_in')
        delete axios.defaults.headers.common['Authorization']
        commit('token_auto_refresh', true)
        resolve()
      })
    },
    refreshToken({commit}){

      let refreshToken = localStorage.getItem('refresh_token')
      axios({
        url: process.env.VUE_APP_URL + '/oauth/token',
        data: 'grant_type=refresh_token&refresh_token='+ refreshToken,
        method: 'POST',
        headers: {
          'Authorization': 'Basic YmktWURYZld0eEw6NWM3YzlkZWQ2ZjkxZTlmNzc0ZmMwYTljZTkwMzMyZTlkYTBhMjA5MTQ2ZDYwODUyMGRmNTY5YWRlMDIwMzY5OQ==',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then(resp => {

        const token = resp.data.access_token
        localStorage.setItem('token', token)
        localStorage.setItem('refresh_token', resp.data.refresh_token)
        const expiresIn = Date.now() + resp.data.expires_in * 1000
        localStorage.setItem('expires_in', expiresIn)
        commit('refresh_token', token)
        commit('token_auto_refresh', false)

        this.dispatch('autoRefreshToken')

      }).catch(err => {

        commit('auth_error', err)
        localStorage.removeItem('token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('expires_in')

      })
    },
    autoRefreshToken({commit}){
      commit('token_auto_refresh', true)
      console.log("auto refresh off")
      const now = Date.now()
      const exp = localStorage.getItem('expires_in')
      let timeUntilRefresh = exp - now
      timeUntilRefresh -= (15 * 60 * 1000)
      console.log(timeUntilRefresh / 1000)
      setTimeout(() => this.dispatch("refreshToken"), timeUntilRefresh)
    }
  }
})
